import { useNavigate } from "react-router-dom";
import { Divider, Grid, Typography } from "@mui/material";

import styles from "../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/modifyWhatsAppTemplate.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";
import GlobalButton from "../../../utility/globalButton/button";
import { useTemplateLibraryStore } from "../../../../store/templateLibraryStore";

function ConnectWabaPopup() {
    
    const navigate = useNavigate();

    const setShowConnectWabaModal = useTemplateLibraryStore((state) => state.setShowConnectWabaModal);

    return (
        <Grid container direction={"column"} gap={"15px"} className={globalStyles.zIndex1}>
            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`} padding={"0px 30px 0px 30px"}>
                <Typography className={styles.popupTitleStyle}>
                    Connect Your WhatsApp Business Account
                </Typography>
            </Grid>

            <Grid item padding={"0 30px 0 30px"}>
                <Divider className={styles.popupDividerStyle} />
            </Grid>

            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.overflowAuto}`}>
                <Grid container direction={"column"} padding={"0px 30px 5px 30px"} gap={"15px"}>
                    <Grid item>
                        <Typography className={styles.popupBodyTextStyle}>
                            To create a template, please connect your WhatsApp Business account first.
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item className={globalStyles.fullwidth} mt={2} padding={"0px 0px 30px 0px"}>
                <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                    <Grid item>
                        <GlobalButton
                            buttonText="Cancel"
                            className="borderedButtonStyle"
                            onClick={() => setShowConnectWabaModal(false)}
                            sx={{ width: "140px !important" }}
                        />
                    </Grid>

                    <Grid item>
                        <GlobalButton
                            buttonText="Connect Now"
                            className="primaryButtonStyle"
                            onClick={() => navigate(`/channels/viewintegration/whatsapp`)}
                            sx={{ width: "140px !important" }}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default ConnectWabaPopup;